import type { ReactNode } from "react";

// The 5-state feedback set (design review): empty · skeleton · error · success ·
// restricted-access. Presentational only — copy passed in from the consumer's i18n.
// Cold-start (empty) is a beginning, not a failure; restricted-access is a trust
// signal, not an error (distinct role/tone).

export function EmptyState({ children }: { children: ReactNode }) {
  return (
    <div className="ui-feedback ui-feedback--empty" role="status" data-testid="ui-empty">
      {children}
    </div>
  );
}

export function ErrorState({ children }: { children: ReactNode }) {
  return (
    <div className="ui-feedback ui-feedback--error" role="alert" data-testid="ui-error">
      {children}
    </div>
  );
}

export function SuccessState({ children }: { children: ReactNode }) {
  return (
    <div className="ui-feedback ui-feedback--success" role="status" data-testid="ui-success">
      {children}
    </div>
  );
}

export function Skeleton({ lines = 3 }: { lines?: number }) {
  return (
    <div aria-hidden="true" data-testid="ui-skeleton">
      {Array.from({ length: lines }, (_, i) => (
        <div key={i} className="ui-skeleton" />
      ))}
    </div>
  );
}

/** A calm "this is protected / advisor-only" state — a trust signal, not an error. */
export function RestrictedAccess({ children }: { children: ReactNode }) {
  return (
    <div className="ui-feedback ui-feedback--restricted" role="note" data-testid="ui-restricted">
      {children}
    </div>
  );
}
